/* Copyright 2013 - 2024 Waiterio LLC */
import product from '@multilocale/shared/product.js'

export default product
